import { getStore } from '../store/store';
import { pop, push, updateTop } from 'owa-navigation-stack';
import { mutator } from 'satcheljs';
import {
    popTimePanelView,
    pushTimePanelView,
    updateTopTimePanelView,
} from '../actions/publicActions';

/**
 * Mutators for view stack
 */

mutator(pushTimePanelView, actionMessage => {
    push(actionMessage.newView, getStore().panelViewStack.stack);
});

mutator(updateTopTimePanelView, actionMessage => {
    updateTop(actionMessage.updatedView, getStore().panelViewStack.stack);
});

mutator(popTimePanelView, () => {
    const { panelViewStack } = getStore();
    pop(panelViewStack.stack);
});
